import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createResourceQueue } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { QUERY_KEYS } from '../../data/constants';
import { toast } from '@pella/sash-framework';

/**
 * Hook containing mutation function for creating a Resource Queue.
 */
export const useCreateResourceQueue = () => {
  const { selectedResource } = useAppContext();
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call the createResourceQueue api.
     * @param {object} params - Parameters for creating a resource queue.
     * @param {Pella.ProductionRequestAPI.Queue['id']} params.queueId - ID of the queue to assign.
     * @param {Pella.ProductionRequestAPI.Resource['id']} [params.resourceId] - ID of the resource.
     * @param {Pella.ProductionRequestAPI.ResourceQueueByStatus['queueStatus']} params.queueStatus - Status of the queue.
     */
    mutationFn: ({ queueId, resourceId, queueStatus }) =>
      createResourceQueue({
        queueId,
        queueStatus,
        resourceId: resourceId ?? selectedResource,
        active: true,
      }),
    onSuccess: (_data, { resourceId }) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_QUEUES, resourceId ?? selectedResource] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_DATA] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.QUEUE_DATA] });
      toast.success('Assignment Successful!');
    },
  });
};
